import { SET_CHANGE_LANGUAGE_VISIBILITY } from 'redux/actionTypes';

const initialState = {
	showChangeLanguageScreen: false,
};

// export const locale[];

const LanguageSupportReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CHANGE_LANGUAGE_VISIBILITY:
			return {
				...state,
				showChangeLanguageScreen: action.data,
			};
		default:
			return state;
	}
};

export default LanguageSupportReducer;
